import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import muallif_1 from '../img/muallif_1.jpg'
import uke from '../img/UKE.jpg'

const Muallif = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button className='button' onClick={showModal}>
                Muallif
            </Button>
            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>

                <div className="muallifbox">
                    <img className='muallif' src={muallif_1} alt="" />
                    <h3 className='name'>Professor <br />AZIZOV AKTAM SHARIPOVICH</h3>
                </div>
                <h4>Toshkent davlat Agrar universitetining “Qishloq xo‘jaligi mahsulotlarini saqlash va qayta ishlash” kafedrasi professori, qishloq xo‘jaligi fanlari doktori, prefessor A.Sh.Azizov 150 dan ortiq ilmiy maqolalar, jumladan 25 dan ortiq xorijiy jurnallardagi maqolalar muallifi
                    <br />
                    azizov.aktamuzb@gmail.com
                </h4>

                <div className="muallifbox2">
                    <img className='muallif muallif2'  src={uke} alt="" />
                    <h3 className='name'>Dosent <br /> USMONOV KAMOLIDDIN EShKULOVICh</h3>
                </div>
                <h4>TIQXMMI Milliy tadqiqot universitetining “Traktorlar va avtomobillar” kafedrasi dotsenti, texnika fanlari falsafa doktori, dotsent K.E. USMONOV 60 dan ortiq ilmiy maqolalar, jumladan 10 dan ortig‘i xorijiy jurnallarda, hamda 4 dan ortiq ixtiro va foydali modellarga olingan patentlarning va 5 ta EHM dasturining muallifi.
                    <br />
                    usmonov-74@inbox.ru
                </h4>
            </Modal>
        </>
    )
}

export default Muallif